import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import DataTables from 'material-ui-datatables';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import _ from 'lodash';

import {
  getTaskCountRoutine,
  fetchInvoicesRoutine,
  getPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  cancelAccountRoutine,
} from '../../routines';
import Dashboard from '../Dashboard';
import Status from '../Common/Status';
import { sortDates, sortStrings, contains, getOrderDirection, buildInvoiceItemDescription } from '../../utils/helper';
import Loading from '../Common/Loading';
import { showDialog, hideDialog } from '../../actions/dialogs';

import styles from './styles';

const getTableColumns = (onDownload) => {
  return _.flatten([
    {
      key: 'from',
      label: 'From',
      render: (a, invoice) => moment(invoice.period.start).format('ll'),
      sortable: true,
      style: styles.fromCol,
    }, {
      key: 'to',
      label: 'To',
      render: (a, invoice) => moment(invoice.period.end).format('ll'),
      sortable: true,
      style: styles.toCol,
    }, {
      key: 'description',
      label: 'Description',
      render: (description, invoice) => invoice.lines.map((line) => <div
        key={line.id}>{buildInvoiceItemDescription(line)}</div>),
      style: styles.descriptionCol,
    }, {
      key: 'accounts',
      label: 'Accounts',
      render: (accounts) => accounts || 1,
      style: styles.accountsCol,
    }, {
      key: 'tasks',
      label: 'Tasks',
      render: (tasks) => tasks,
      sortable: true,
      style: styles.tasksCol,
    }, {
      key: 'taskCost',
      label: 'Task Cost',
      render: (taskCost) => Number(taskCost).toFixed(2),
      sortable: true,
      style: styles.taskCostCol,
    }, {
      key: 'amount',
      label: 'Amount',
      render: (amount) => `$${amount.toFixed(2)}`,
      sortable: true,
      style: styles.amountCol,
    }, {
      key: 'paid',
      label: 'Status',
      render: (paid) => paid ? <Status label="Paid" containerStyle={styles.paid}/> :
        <Status label="Outstanding" containerStyle={styles.outstanding}/>,
      style: styles.statusCol,
      // }, {
      //   key: 'action',
      //   label: '',
      //   render: (a, invoice) => {
      //     return (<span><IconButton
      //       tooltip="Download"
      //       tooltipPosition="bottom-center"
      //       onClick={(evt) => onDownload(evt, invoice)}
      //     >
      //       <FontIcon
      //         className="material-icons"
      //         style={styles.icon}
      //       >file_download</FontIcon>
      //     </IconButton>
      //       </span>);
      //   },
      //   alignRight: true,
      //   style: styles.actionCol,
    },
  ]);
};

const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
  return (a, b) => {
    let result = sorter(a, b) * getOrderDirection(order);

    if (result === 0) {
      result = sortDates(a.period.start, b.period.start);

      if (result === 0) {
        result = sortDates(a.period.end, b.period.end);

        if (result === 0) {
          result = sortStrings(a.id, b.id);
        }
      }
    }

    return result;
  };
};

const getInvoiceFilter = (filter) => {
  return (invoice) => {
    if (filter) {
      if (contains(invoice.description, filter)) {
        return true;
      }
      // if (job.customer && contains(job.customer.name, filter)) {
      //   return true;
      // }

      return false;
    }

    return true;
  };
};

const isFreePlan = (tenant) => {
  console.log('tenant', tenant);
  return !(tenant.settings && tenant.settings.plan && tenant.settings.plan.toLowerCase() !== 'free');
};

class Billing extends Component {
  static propTypes = {
    fetchInvoices: PropTypes.func.isRequired,
    invoices: PropTypes.array.isRequired,
    loadingInvoices: PropTypes.bool.isRequired,
    tenant: PropTypes.object.isRequired,

    currentUser: PropTypes.object,
    taskCount: PropTypes.number.isRequired,
    getTaskCount: PropTypes.func.isRequired,
    paymentSource: PropTypes.object,
    getPaymentSource: PropTypes.func.isRequired,
    updatePaymentSource: PropTypes.func.isRequired,
    cancelAccount: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {
    selectedRows: [],
    page: 1,
    limit: 10,
    sortBy: getSorter((a, b) => sortDates(a.period.start, b.period.start), 'desc'),
    order: 'asc',
    data: [],
  };

  componentWillMount() {
    if (this.props.currentUser) {
      this.props.fetchInvoices();
      this.props.getTaskCount({ tenantId: this.props.tenant.id });
      this.props.getPaymentSource({ tenantId: this.props.tenant.id });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentUser && !this.props.currentUser) {
      nextProps.fetchInvoices();
      nextProps.getTaskCount({ tenantId: nextProps.tenant.id });
      this.props.getPaymentSource({ tenantId: nextProps.tenant.id });
    }

    if (nextProps.invoices) {
      this.setState({
        data: nextProps.invoices.sort(this.state.sortBy),
      });
    }
  }

  handleDownload = (invoice) => {
    alert('Not supported');
  };

  handleFilterValueChange = (filter) => {
    const { invoices } = this.props;
    const { page, limit, sortBy } = this.state;

    const data = invoices.filter(getInvoiceFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
    this.setState({
      page: Math.min(page, Math.floor(data.length / limit) + 1),
      data,
    });
  };

  handleSortOrderChange = (key, order) => {
    let sortBy = getSorter();
    switch (key) {
      case 'start':
        sortBy = getSorter((a, b) => sortDates(a.period.start, b.period.start), order);
        break;
      case 'end':
        sortBy = getSorter((a, b) => sortDates(a.period.end, b.period.end), order);
        break;
      case 'tasks':
        sortBy = getSorter((a, b) => (a.tasks || 0) - (b.tasks || 0), order);
        break;
      case 'amount':
        sortBy = getSorter((a, b) => (a.amount || 0) - (b.amount || 0), order);
        break;
      default:
        break;
    }

    this.setState({
      data: this.state.data.sort(sortBy),
      sortBy,
    });
  };

  handlePreviousPageClick = () => {
    this.setState({
      page: Math.max(1, this.state.page - 1),
    });
  };

  handleNextPageClick = () => {
    const { data, page, limit } = this.state;

    this.setState({
      page: Math.min(Math.ceil(data.length / limit), page + 1),
    });
  };

  handleRowSizeChange = (a, limit) => {
    this.setState({
      limit,
      page: 1,
    });
  };

  handleUpgrade = () => {
    this.props.showDialog('upgrade');
  };

  handleChangePaymentSource = () => {
    this.props.showDialog('creditcard', {
      onRequestClose: ({ token }) => {
        console.log('token', token);
        this.props.updatePaymentSource({ token });
      },
    });
  };

  handleCancelAccount = () => {
    console.log('handleCancelAccount');
    const context = {
      type: 'severe',
      title: 'Cancel Account?',
      message: 'All access will be removed and your data will be deleted. Are you sure you wish to cancel your account?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
            this.props.cancelAccount();
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  renderNoData() {
    return (<TableRow key="nodata">
      <TableRowColumn colSpan={6} style={styles.noDataRow}>
        <FontIcon className="material-icons" style={styles.noData}>monetization_on</FontIcon>
        <div>No invoices currently available</div>
      </TableRowColumn>
    </TableRow>);
  }

  render() {
    const { tenant, loadingInvoices, taskCount, paymentSource } = this.props;
    const { page, data, limit } = this.state;
    return (
      <Dashboard title="Billing">
        <div style={styles.wrapper}>
          <div style={styles.row}>
            <Paper style={styles.paperNarrow}>
              <div style={styles.paperTitle}>Current Tasks</div>
              <div style={styles.paperBody}>{ taskCount < 0 ? <img alt="Loading" src="/images/spinner.gif" height={80}/> : taskCount }</div>
            </Paper>
            <Paper style={styles.paper}>
              <div style={styles.row}>
                <div style={{ flex: 1 }}>
                  <div style={styles.paperTitle}>Current Plan</div>
                  <div style={styles.paperBody}>
                    { isFreePlan(tenant) ? 'Free' : tenant.settings.plan.split('-')[0] }
                  </div>
                </div>
                <div style={styles.actionButton}>
                  <IconButton
                    tooltip="Cancel Account"
                    tooltipPosition="bottom-center"
                    onClick={this.handleCancelAccount}
                  >
                    <FontIcon className="material-icons" style={styles.icon} color="red">cancel</FontIcon>
                  </IconButton>
                </div>
              </div>
            </Paper>
            <Paper style={styles.paperNarrow}>
              <div style={styles.row}>
                <div style={{ flex: 1 }}>
                  <div style={styles.paperTitle}>Data Retention Period</div>
                  { isFreePlan(tenant) ? <div style={styles.paperBody}>14 days</div> :
                    <div style={styles.paperBody}>{ tenant.settings ? tenant.settings.retentionPeriod : 1 } <span
                      style={styles.month}>month{ tenant.settings && tenant.settings.retentionPeriod > 1 ? 's' : '' }</span>
                    </div> }
                </div>
                { !isFreePlan(tenant) ? <div style={styles.actionButton}>
                  <IconButton
                    tooltip="Upgrade"
                    tooltipPosition="bottom-center"
                    onClick={this.handleUpgrade}
                  >
                    <FontIcon className="material-icons" style={styles.icon}>swap_vert</FontIcon>
                  </IconButton>
                </div> : null }
              </div>
            </Paper>
            { paymentSource ? <Paper style={styles.paper}>
              <div style={styles.row}>
                <div style={styles.paperBodySmall}>
                  <div style={styles.paperTitle}>Payment Source</div>
                  <div>Type: { paymentSource.brand }</div>
                  <div>Last 4: ...{ paymentSource.last4 }</div>
                  <div>Expiry: { paymentSource.expiry.month }/{ paymentSource.expiry.year }</div>
                </div>
                <div style={styles.actionButton}>
                  <IconButton
                    tooltip="Change"
                    tooltipPosition="bottom-center"
                    onClick={this.handleChangePaymentSource}
                  >
                    <FontIcon className="material-icons" style={styles.icon}>refresh</FontIcon>
                  </IconButton>
                </div>
              </div>
            </Paper> : null }
          </div>
          { !loadingInvoices ? <DataTables
            height={'auto'}
            showRowHover
            columns={getTableColumns(this.handleDownload)}
            data={data.slice((page - 1) * limit, page * limit)}
            onFilterValueChange={this.handleFilterValueChange}
            onSortOrderChange={this.handleSortOrderChange}
            onPreviousPageClick={this.handlePreviousPageClick}
            onNextPageClick={this.handleNextPageClick}
            onRowSizeChange={this.handleRowSizeChange}
            page={page}
            rowSize={limit}
            rowSizeList={[10, 15, 25, 50, 100]}
            count={data.length}
            filterHintText="Filter"
            headerToolbarMode="filter"
            showHeaderToolbar
          /> : <Loading/> }
        </div>
      </Dashboard>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentUser: state.get('authentication').get('user'),
    invoices: state.get('tenants').get('invoices').toJS(),
    loadingInvoices: state.get('tenants').get('loadingInvoices'),
    tenant: state.get('tenants').get('tenant').toJS(),
    taskCount: state.get('tenants').get('taskCount'),
    paymentSource: state.get('tenants').get('paymentSource') ? state.get('tenants').get('paymentSource').toJS() : null,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchInvoices: fetchInvoicesRoutine.trigger,
    getTaskCount: getTaskCountRoutine.trigger,
    getPaymentSource: getPaymentSourceRoutine.trigger,
    updatePaymentSource: updatePaymentSourceRoutine.trigger,
    cancelAccount: cancelAccountRoutine.trigger,

    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Billing);



// WEBPACK FOOTER //
// ./src/components/Billing/index.js